(() => {
  "use strict";

  /* ======================================================
     EASY SETTINGS
     ====================================================== */

  const SETTINGS = {
    /*
      Link onderaan tonen of verbergen.
      true  = tonen
      false = verbergen
    */
    showAllReviewsLink: true,

    /*
      Automatisch scrollen.
    */
    autoplayEnabled: true,

    /*
      Tijd tussen slides in milliseconden.
      5000 = 5 seconden.
    */
    autoplayDelay: 5000,

    /*
      Pauzeren wanneer muis boven carousel staat.
    */
    pauseAutoplayOnHover: true,

    /*
      Pauzeren wanneer carousel focus heeft.
    */
    pauseAutoplayOnFocus: true,

    /*
      Pauzeren wanneer browsertabblad niet actief is.
    */
    pauseAutoplayWhenHidden: true,

    /*
      Respecteer reduced-motion instelling.
    */
    respectReducedMotion: true
  };

  const BLOCK_SELECTOR =
    '[id*="judge_me_reviews_featured_carousel"]';

  const ORIGINAL_CAROUSEL_SELECTOR =
    "section.jdgm-widget.jdgm-carousel";

  const DEFAULT_REVIEWS_PATH =
    "/pages/reviews";

  const MAX_REVIEWS = 20;

  /* ======================================================
     TRANSLATIONS
     ====================================================== */

  const TRANSLATIONS = {
    nl: {
      heading:
        "+100.000 Gelukkige Ouders & Kinderen",

      eyebrow:
        "ERVARINGEN VAN ONZE KLANTEN",

      allReviews:
        "Bekijk alle reviews",

      previous:
        "Vorige review",

      next:
        "Volgende review",

      goTo:
        "Ga naar review",

      verified:
        "Geverifieerde review",

      verifiedShort:
        "Geverifieerd",

      carousel:
        "Klantbeoordelingen",

      fallbackTitle:
        "Ervaring van een klant",

      fallbackAuthor:
        "Vrooomy-klant"
    },

    en: {
      heading:
        "100,000+ Happy Parents and Children",

      eyebrow:
        "EXPERIENCES FROM OUR CUSTOMERS",

      allReviews:
        "View all reviews",

      previous:
        "Previous review",

      next:
        "Next review",

      goTo:
        "Go to review",

      verified:
        "Verified review",

      verifiedShort:
        "Verified",

      carousel:
        "Customer reviews",

      fallbackTitle:
        "Customer experience",

      fallbackAuthor:
        "Vrooomy customer"
    },

    fr: {
      heading:
        "Plus de 100 000 Parents et Enfants Heureux",

      eyebrow:
        "EXPÉRIENCES DE NOS CLIENTS",

      allReviews:
        "Voir tous les avis",

      previous:
        "Avis précédent",

      next:
        "Avis suivant",

      goTo:
        "Aller à l’avis",

      verified:
        "Avis vérifié",

      verifiedShort:
        "Vérifié",

      carousel:
        "Avis clients",

      fallbackTitle:
        "Expérience d’un client",

      fallbackAuthor:
        "Client Vrooomy"
    },

    de: {
      heading:
        "Über 100.000 Glückliche Eltern und Kinder",

      eyebrow:
        "ERFAHRUNGEN UNSERER KUNDEN",

      allReviews:
        "Alle Bewertungen ansehen",

      previous:
        "Vorherige Bewertung",

      next:
        "Nächste Bewertung",

      goTo:
        "Zur Bewertung",

      verified:
        "Verifizierte Bewertung",

      verifiedShort:
        "Verifiziert",

      carousel:
        "Kundenbewertungen",

      fallbackTitle:
        "Erfahrung eines Kunden",

      fallbackAuthor:
        "Vrooomy-Kunde"
    },

    es: {
      heading:
        "Más de 100.000 Padres y Niños Felices",

      eyebrow:
        "EXPERIENCIAS DE NUESTROS CLIENTES",

      allReviews:
        "Ver todas las reseñas",

      previous:
        "Reseña anterior",

      next:
        "Siguiente reseña",

      goTo:
        "Ir a la reseña",

      verified:
        "Reseña verificada",

      verifiedShort:
        "Verificada",

      carousel:
        "Reseñas de clientes",

      fallbackTitle:
        "Experiencia de un cliente",

      fallbackAuthor:
        "Cliente de Vrooomy"
    },

    pt: {
      heading:
        "Mais de 100.000 Pais e Crianças Felizes",

      eyebrow:
        "EXPERIÊNCIAS DOS NOSSOS CLIENTES",

      allReviews:
        "Ver todas as avaliações",

      previous:
        "Avaliação anterior",

      next:
        "Próxima avaliação",

      goTo:
        "Ir para a avaliação",

      verified:
        "Avaliação verificada",

      verifiedShort:
        "Verificada",

      carousel:
        "Avaliações de clientes",

      fallbackTitle:
        "Experiência de um cliente",

      fallbackAuthor:
        "Cliente Vrooomy"
    },

    it: {
      heading:
        "Oltre 100.000 Genitori e Bambini Felici",

      eyebrow:
        "ESPERIENZE DEI NOSTRI CLIENTI",

      allReviews:
        "Vedi tutte le recensioni",

      previous:
        "Recensione precedente",

      next:
        "Recensione successiva",

      goTo:
        "Vai alla recensione",

      verified:
        "Recensione verificata",

      verifiedShort:
        "Verificata",

      carousel:
        "Recensioni dei clienti",

      fallbackTitle:
        "Esperienza di un cliente",

      fallbackAuthor:
        "Cliente Vrooomy"
    },

    pl: {
      heading:
        "Ponad 100 000 Szczęśliwych Rodziców i Dzieci",

      eyebrow:
        "DOŚWIADCZENIA NASZYCH KLIENTÓW",

      allReviews:
        "Zobacz wszystkie opinie",

      previous:
        "Poprzednia opinia",

      next:
        "Następna opinia",

      goTo:
        "Przejdź do opinii",

      verified:
        "Zweryfikowana opinia",

      verifiedShort:
        "Zweryfikowana",

      carousel:
        "Opinie klientów",

      fallbackTitle:
        "Doświadczenie klienta",

      fallbackAuthor:
        "Klient Vrooomy"
    }
  };

  /* ======================================================
     LANGUAGE DETECTION
     ====================================================== */

  function detectLocale() {
    const pathParts =
      window.location.pathname
        .split("/")
        .filter(Boolean);

    const firstPathPart =
      pathParts[0]
        ?.toLowerCase() || "";

    const pathLanguage =
      firstPathPart
        .split("-")[0];

    if (
      TRANSLATIONS[pathLanguage]
    ) {
      return {
        language:
          pathLanguage,

        prefix:
          `/${firstPathPart}`
      };
    }

    const htmlLanguage =
      (
        document.documentElement.lang ||
        ""
      )
        .toLowerCase()
        .split("-")[0];

    if (
      TRANSLATIONS[htmlLanguage]
    ) {
      return {
        language:
          htmlLanguage,

        prefix:
          ""
      };
    }

    return {
      language:
        "nl",

      prefix:
        ""
    };
  }

  const LOCALE =
    detectLocale();

  const LANGUAGE =
    LOCALE.language;

  const COPY =
    TRANSLATIONS[LANGUAGE];

  /* ======================================================
     HELPERS
     ====================================================== */

  const cleanText = (value) =>
    String(value || "")
      .replace(
        /[\u200B-\u200D\uFEFF]/g,
        ""
      )
      .replace(/\s+/g, " ")
      .replace(
        /^[|/\\•·—-]+\s*/,
        ""
      )
      .trim();

  const modulo = (
    value,
    divisor
  ) =>
    (
      (value % divisor) +
      divisor
    ) %
    divisor;

  function getFirstText(
    root,
    selectors
  ) {
    for (
      const selector of
      selectors
    ) {
      const element =
        root.querySelector(
          selector
        );

      if (!element) {
        continue;
      }

      const text =
        cleanText(
          element.innerText ||
          element.textContent ||
          ""
        );

      if (text) {
        return text;
      }
    }

    return "";
  }

  function prefersReducedMotion() {
    if (
      !SETTINGS.respectReducedMotion
    ) {
      return false;
    }

    return Boolean(
      window.matchMedia?.(
        "(prefers-reduced-motion: reduce)"
      ).matches
    );
  }

  /* ======================================================
     HEADER
     ====================================================== */

  function forceCorrectHeading(
    block
  ) {
    const heading =
      block.querySelector(
        ".jdgm-carousel-title"
      );

    if (!heading) {
      return;
    }

    /*
      Dit vervangt onmiddellijk de door Judge.me
      gegenereerde tekst voor toegankelijkheid en SEO.
    */

    if (
      heading.textContent !==
      COPY.heading
    ) {
      heading.textContent =
        COPY.heading;
    }

    heading.setAttribute(
      "aria-label",
      COPY.heading
    );

    /*
      De zichtbare titel wordt via CSS ::after getoond,
      zodat de oorspronkelijke Judge.me-titel niet kort flitst.
      JSON.stringify levert een geldige gequote CSS-string op.
    */
    block.style.setProperty(
      "--vry-heading",
      JSON.stringify(
        COPY.heading
      )
    );
  }


  /*
    Verwijder Judge.me-check-/brandingiconen uit de samenvatting
    boven de carousel. De sterren en het reviewaantal blijven staan.

    Dit voorkomt dat hetzelfde turquoise Judge.me-icoon twee keer
    verschijnt wanneer Judge.me of het Shopify-thema het dubbel injecteert.
  */
  function removeJudgeMeHeaderIcons(
    block
  ) {
    const ratingWrapper =
      block.querySelector(
        ".jdgm-all-reviews-rating-wrapper"
      );

    if (!ratingWrapper) {
      return;
    }

    /*
      Verwijder bekende badgecontainers volledig.
    */
    ratingWrapper
      .querySelectorAll(
        [
          ".jdgm-verified-badge-wrapper",
          ".jdgm-verified-badge",
          '[class*="verified-badge"]',
          '[class*="checkmark"]',
          '[class*="judgeme-icon"]',
          '[class*="judge-me-icon"]'
        ].join(",")
      )
      .forEach(
        (element) => {
          if (
            !element.closest(
              ".jdgm-all-reviews-rating"
            )
          ) {
            element.remove();
          }
        }
      );

    /*
      Judge.me kan de check ook als losse SVG of afbeelding injecteren.
      Elementen binnen de echte sterrenrating worden bewust behouden.
    */
    ratingWrapper
      .querySelectorAll(
        "svg, img"
      )
      .forEach(
        (element) => {
          if (
            !element.closest(
              ".jdgm-all-reviews-rating"
            )
          ) {
            element.remove();
          }
        }
      );
  }

  function createOrUpdateEyebrow(
    block
  ) {
    const wrapper =
      block.querySelector(
        ".jdgm-carousel-title-and-link"
      );

    if (!wrapper) {
      return;
    }

    let eyebrow =
      wrapper.querySelector(
        ".vry-eyebrow"
      );

    if (!eyebrow) {
      eyebrow =
        document.createElement(
          "div"
        );

      eyebrow.className =
        "vry-eyebrow";

      const heading =
        wrapper.querySelector(
          ".jdgm-carousel-title"
        );

      if (heading) {
        wrapper.insertBefore(
          eyebrow,
          heading
        );
      } else {
        wrapper.prepend(
          eyebrow
        );
      }
    }

    eyebrow.textContent =
      COPY.eyebrow;

    eyebrow.setAttribute(
      "lang",
      LANGUAGE
    );

    eyebrow.hidden =
      false;
  }

  function updateHeader(
    block
  ) {
    forceCorrectHeading(
      block
    );

    removeJudgeMeHeaderIcons(
      block
    );

    createOrUpdateEyebrow(
      block
    );

    block.classList.add(
      "vry-ready"
    );
  }

  /* ======================================================
     RATING
     ====================================================== */

  function parseRating(value) {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return null;
    }

    const normalized =
      String(value)
        .replace(",", ".")
        .trim();

    const direct =
      Number.parseFloat(
        normalized
      );

    if (
      Number.isFinite(direct) &&
      direct >= 1 &&
      direct <= 5 &&
      normalized.length <= 4
    ) {
      return Math.round(
        direct
      );
    }

    const match =
      normalized.match(
        /([1-5](?:\.\d+)?)\s*(?:\/\s*5|van\s*5|out\s+of\s+5|stars?|sterren)/i
      );

    if (!match) {
      return null;
    }

    return Math.max(
      1,
      Math.min(
        5,
        Math.round(
          Number.parseFloat(
            match[1]
          )
        )
      )
    );
  }

  function getRating(item) {
    const elements = [
      item,

      ...item.querySelectorAll(
        [
          ".jdgm-carousel-item__review-rating",
          ".jdgm-rev__rating",
          "[data-score]",
          "[data-rating]",
          "[data-value]"
        ].join(",")
      )
    ];

    for (
      const element of
      elements
    ) {
      const values = [
        element.dataset?.score,
        element.dataset?.rating,
        element.dataset?.value,

        element.getAttribute?.(
          "data-score"
        ),

        element.getAttribute?.(
          "data-rating"
        ),

        element.getAttribute?.(
          "data-value"
        ),

        element.getAttribute?.(
          "aria-label"
        ),

        element.getAttribute?.(
          "title"
        )
      ];

      for (
        const value of
        values
      ) {
        const rating =
          parseRating(value);

        if (
          rating !== null
        ) {
          return rating;
        }
      }
    }

    const stars = [
      ...item.querySelectorAll(
        ".jdgm-star"
      )
    ];

    if (stars.length) {
      const filled =
        stars.filter(
          (star) =>
            star.classList.contains(
              "jdgm--on"
            ) ||
            star.classList.contains(
              "jdgm-star--on"
            ) ||
            star.classList.contains(
              "active"
            ) ||
            star.classList.contains(
              "filled"
            )
        ).length;

      const half =
        stars.filter(
          (star) =>
            star.classList.contains(
              "jdgm--half"
            ) ||
            star.classList.contains(
              "jdgm-star--half"
            ) ||
            star.classList.contains(
              "half"
            )
        ).length;

      if (
        filled ||
        half
      ) {
        return Math.max(
          1,
          Math.min(
            5,
            Math.round(
              filled +
              half * 0.5
            )
          )
        );
      }
    }

    const ratingText =
      cleanText(
        item.querySelector(
          ".jdgm-carousel-item__review-rating, .jdgm-rev__rating"
        )?.textContent
      );

    const starsInText =
      (
        ratingText.match(
          /★/g
        ) ||
        []
      ).length;

    return starsInText
      ? Math.min(
          starsInText,
          5
        )
      : 5;
  }

  /* ======================================================
     VERIFIED
     ====================================================== */

  function isVerifiedReview(
    item
  ) {
    const text =
      cleanText(
        item.innerText ||
        item.textContent ||
        ""
      );

    const element =
      item.querySelector(
        [
          ".jdgm-rev__buyer-badge",
          ".jdgm-rev__buyer-badge-wrapper",
          '[class*="verified"]',
          '[aria-label*="verified" i]',
          '[title*="verified" i]',
          '[aria-label*="geverifieerd" i]',
          '[title*="geverifieerd" i]'
        ].join(",")
      );

    return Boolean(
      element ||
      /[✓✔]/.test(text)
    );
  }

  /* ======================================================
     REVIEW DATA
     ====================================================== */

  function getReviewData(
    item
  ) {
    const title =
      getFirstText(
        item,
        [
          ".jdgm-carousel-item__review-title",
          ".jdgm-rev__title",
          '[class*="review-title"]'
        ]
      );

    let body =
      getFirstText(
        item,
        [
          ".jdgm-carousel-item__review-body",
          ".jdgm-rev__body",
          ".jdgm-rev__body > p",
          '[class*="review-body"]'
        ]
      );

    const rawAuthor =
      getFirstText(
        item,
        [
          ".jdgm-carousel-item__reviewer-name",
          ".jdgm-rev__author",
          '[class*="reviewer-name"]',
          '[class*="review-author"]'
        ]
      );

    if (
      title &&
      body &&
      title.toLowerCase() ===
        body.toLowerCase()
    ) {
      body = "";
    }

    return {
      title,
      body,

      author:
        cleanText(
          rawAuthor
            .replace(
              /[✓✔]/g,
              ""
            )
            .replace(
              /^—\s*/,
              ""
            )
        ),

      rating:
        getRating(item),

      verified:
        isVerifiedReview(
          item
        )
    };
  }

  function collectReviewItems(
    block,
    originalCarousel
  ) {
    const items =
      new Set(
        originalCarousel.querySelectorAll(
          ".jdgm-carousel-item"
        )
      );

    const section =
      block.closest(
        ".shopify-section"
      ) ||
      block.parentElement ||
      document;

    section
      .querySelectorAll(
        ".jdgm-rev, [data-review-id]"
      )
      .forEach((item) => {
        if (
          !item.closest(
            ".vry-root"
          )
        ) {
          items.add(item);
        }
      });

    return [...items];
  }

  function deduplicateReviews(
    reviews
  ) {
    const seen =
      new Set();

    return reviews.filter(
      (review) => {
        const key = [
          review.title,
          review.body,
          review.author
        ]
          .map(
            (part) =>
              cleanText(part)
                .toLowerCase()
          )
          .join("|");

        if (
          !key.replace(
            /\|/g,
            ""
          ) ||
          seen.has(key)
        ) {
          return false;
        }

        seen.add(key);

        return true;
      }
    );
  }

  function getReviews(
    block,
    originalCarousel
  ) {
    return deduplicateReviews(
      collectReviewItems(
        block,
        originalCarousel
      )
        .map(
          getReviewData
        )
        .filter(
          (review) =>
            review.title ||
            review.body
        )
    )
      .slice(
        0,
        MAX_REVIEWS
      )
      .map(
        (
          review,
          index
        ) => ({
          ...review,
          index
        })
      );
  }

  /* ======================================================
     CONTENT HELPERS
     ====================================================== */

  function getReviewTitle(
    review
  ) {
    if (review.title) {
      return review.title;
    }

    if (!review.body) {
      return (
        COPY.fallbackTitle
      );
    }

    const sentence =
      review.body
        .split(/[.!?]/)[0]
        .trim();

    if (
      sentence.length <= 64
    ) {
      return sentence;
    }

    return `${sentence
      .slice(0, 61)
      .trim()}…`;
  }

  function getReviewsUrl(
    block
  ) {
    const originalLink =
      block.querySelector(
        ".jdgm-all-reviews-rating-wrapper"
      );

    const href =
      originalLink
        ?.getAttribute(
          "href"
        )
        ?.trim() ||
      "";

    const invalid =
      !href ||
      href === "#" ||
      href
        .toLowerCase()
        .startsWith(
          "javascript"
        );

    if (invalid) {
      return (
        `${LOCALE.prefix}` +
        DEFAULT_REVIEWS_PATH
      );
    }

    if (
      /^https?:\/\//i.test(
        href
      ) ||
      href.startsWith("//")
    ) {
      return href;
    }

    if (
      LOCALE.prefix &&
      href.startsWith(
        "/pages/"
      ) &&
      !href.startsWith(
        `${LOCALE.prefix}/`
      )
    ) {
      return (
        `${LOCALE.prefix}${href}`
      );
    }

    if (
      LOCALE.prefix &&
      href.startsWith(
        "pages/"
      )
    ) {
      return (
        `${LOCALE.prefix}/` +
        href
      );
    }

    return href;
  }

  /* ======================================================
     ELEMENTS
     ====================================================== */

  function createArrow(
    direction
  ) {
    const button =
      document.createElement(
        "button"
      );

    const previous =
      direction ===
      "previous";

    const label =
      previous
        ? COPY.previous
        : COPY.next;

    button.type =
      "button";

    button.className =
      `vry-arrow vry-arrow--${direction}`;

    button.setAttribute(
      "aria-label",
      label
    );

    button.title =
      label;

    button.innerHTML =
      previous
        ? `
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 18l-6-6 6-6"></path>
          </svg>
        `
        : `
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 6l6 6-6 6"></path>
          </svg>
        `;

    return button;
  }

  function createVerifiedBadge() {
    const badge =
      document.createElement(
        "span"
      );

    badge.className =
      "vry-verified";

    badge.setAttribute(
      "aria-label",
      COPY.verified
    );

    badge.title =
      COPY.verified;

    const icon =
      document.createElement(
        "span"
      );

    icon.className =
      "vry-verified__icon";

    icon.innerHTML = `
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <path d="M3.2 8.2 6.4 11l6.4-6.5"></path>
      </svg>
    `;

    const label =
      document.createElement(
        "span"
      );

    label.className =
      "vry-verified__label";

    label.textContent =
      COPY.verifiedShort;

    badge.append(
      icon,
      label
    );

    return badge;
  }

  function createCard(
    review,
    isClone = false
  ) {
    const card =
      document.createElement(
        "article"
      );

    card.className =
      "vry-card";

    card.dataset.rating =
      String(
        review.rating
      );

    if (
      review.body.length < 30
    ) {
      card.classList.add(
        "vry-card--short"
      );
    }

    if (
      review.body.length > 170
    ) {
      card.classList.add(
        "vry-card--long"
      );
    }

    if (isClone) {
      card.dataset.clone =
        "true";

      card.setAttribute(
        "aria-hidden",
        "true"
      );
    }

    const inner =
      document.createElement(
        "div"
      );

    inner.className =
      "vry-card__inner";

    const top =
      document.createElement(
        "div"
      );

    top.className =
      "vry-card__top";

    const stars =
      document.createElement(
        "div"
      );

    stars.className =
      "vry-card__stars";

    stars.setAttribute(
      "aria-label",
      `${review.rating} / 5`
    );

    stars.textContent =
      "★".repeat(
        review.rating
      ) +
      "☆".repeat(
        5 -
        review.rating
      );

    top.appendChild(
      stars
    );

    if (
      review.verified
    ) {
      top.appendChild(
        createVerifiedBadge()
      );
    }

    const title =
      document.createElement(
        "h3"
      );

    title.className =
      "vry-card__title";

    title.textContent =
      getReviewTitle(
        review
      );

    title.title =
      title.textContent;

    inner.append(
      top,
      title
    );

    if (review.body) {
      const body =
        document.createElement(
          "p"
        );

      body.className =
        "vry-card__body";

      body.textContent =
        review.body;

      body.title =
        review.body;

      inner.appendChild(
        body
      );
    }

    const footer =
      document.createElement(
        "div"
      );

    footer.className =
      "vry-card__footer";

    const author =
      document.createElement(
        "div"
      );

    author.className =
      "vry-author";

    const name =
      document.createElement(
        "span"
      );

    name.className =
      "vry-author__name";

    name.textContent =
      review.author ||
      COPY.fallbackAuthor;

    author.appendChild(
      name
    );

    footer.appendChild(
      author
    );

    inner.appendChild(
      footer
    );

    card.appendChild(
      inner
    );

    return card;
  }

  function createAllReviewsLink(
    url
  ) {
    const bottom =
      document.createElement(
        "div"
      );

    bottom.className =
      "vry-bottom";

    const link =
      document.createElement(
        "a"
      );

    link.className =
      "vry-all-reviews";

    link.href =
      url;

    const label =
      document.createElement(
        "span"
      );

    label.textContent =
      COPY.allReviews;

    const icon =
      document.createElement(
        "span"
      );

    icon.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 12h13"></path>
        <path d="M14 7l5 5-5 5"></path>
      </svg>
    `;

    link.append(
      label,
      icon
    );

    bottom.appendChild(
      link
    );

    return bottom;
  }

  /* ======================================================
     CAROUSEL
     ====================================================== */

  function enhanceBlock(
    block
  ) {
    updateHeader(
      block
    );

    if (
      block.querySelector(
        ".vry-root"
      )
    ) {
      return;
    }

    const originalCarousel =
      block.querySelector(
        ORIGINAL_CAROUSEL_SELECTOR
      );

    if (
      !originalCarousel
    ) {
      return;
    }

    const reviews =
      getReviews(
        block,
        originalCarousel
      );

    if (
      !reviews.length
    ) {
      return;
    }

    const root =
      document.createElement(
        "div"
      );

    root.className =
      "vry-root";

    root.setAttribute(
      "aria-label",
      COPY.carousel
    );

    const stage =
      document.createElement(
        "div"
      );

    stage.className =
      "vry-stage";

    const previousButton =
      createArrow(
        "previous"
      );

    const nextButton =
      createArrow(
        "next"
      );

    const viewport =
      document.createElement(
        "div"
      );

    viewport.className =
      "vry-viewport";

    viewport.tabIndex =
      0;

    const track =
      document.createElement(
        "div"
      );

    track.className =
      "vry-track";

    viewport.appendChild(
      track
    );

    const dots =
      document.createElement(
        "div"
      );

    dots.className =
      "vry-dots";

    stage.append(
      previousButton,
      viewport,
      nextButton
    );

    root.append(
      stage,
      dots
    );

    if (
      SETTINGS.showAllReviewsLink
    ) {
      root.appendChild(
        createAllReviewsLink(
          getReviewsUrl(
            block
          )
        )
      );
    }

    originalCarousel.replaceWith(
      root
    );

    previousButton.hidden =
      reviews.length <= 1;

    nextButton.hidden =
      reviews.length <= 1;

    let config =
      null;

    let cloneCount =
      0;

    let currentIndex =
      0;

    let touchStartX =
      null;

    let touchStartY =
      null;

    let resizeTimer =
      null;

    let autoplayTimer =
      null;

    let isHovering =
      false;

    let hasFocusWithin =
      false;

    let isTouching =
      false;

    /* ====================================================
       RESPONSIVE SETTINGS
       ==================================================== */

    function getConfig() {
      const width =
        viewport
          .getBoundingClientRect()
          .width ||
        window.innerWidth;

      if (
        width < 750
      ) {
        return {
          visibleCards: 1,
          gap: 14,
          peek: 42,
          minimumWidth: 230
        };
      }

      if (
        width < 1100
      ) {
        return {
          visibleCards: 3,
          gap: 16,
          peek: 26,
          minimumWidth: 190
        };
      }

      if (
        width < 1200
      ) {
        return {
          visibleCards: 4,
          gap: 16,
          peek: 34,
          minimumWidth: 185
        };
      }

      return {
        visibleCards: 5,
        gap: 16,
        peek: 32,
        minimumWidth: 180
      };
    }

    function getActiveIndex() {
      return modulo(
        currentIndex -
        cloneCount,
        reviews.length
      );
    }

    function getCardWidth() {
      return (
        track
          .querySelector(
            ".vry-card"
          )
          ?.getBoundingClientRect()
          .width ||
        0
      );
    }

    function applyDimensions() {
      const viewportWidth =
        viewport
          .getBoundingClientRect()
          .width;

      const gapWidth =
        (
          config.visibleCards -
          1
        ) *
        config.gap;

      const availableWidth =
        viewportWidth -
        config.peek * 2 -
        gapWidth;

      const cardWidth =
        availableWidth /
        config.visibleCards;

      track.style.setProperty(
        "--vry-gap",
        `${config.gap}px`
      );

      track.style.setProperty(
        "--vry-card-width",
        `${Math.max(
          cardWidth,
          config.minimumWidth
        )}px`
      );
    }

    function updatePosition(
      animate = true
    ) {
      const cardWidth =
        getCardWidth();

      if (!cardWidth) {
        return;
      }

      track.classList.toggle(
        "is-jumping",
        !animate
      );

      const step =
        cardWidth +
        config.gap;

      const translation =
        config.peek -
        currentIndex *
        step;

      track.style.transform =
        `translate3d(${translation}px, 0, 0)`;

      renderDots();

      if (!animate) {
        requestAnimationFrame(
          () => {
            track.classList.remove(
              "is-jumping"
            );
          }
        );
      }
    }

    function buildCarousel(
      activeIndex = 0
    ) {
      config =
        getConfig();

      cloneCount =
        Math.min(
          reviews.length,
          config.visibleCards +
          1
        );

      const before =
        reviews.slice(
          reviews.length -
          cloneCount
        );

      const after =
        reviews.slice(
          0,
          cloneCount
        );

      track.innerHTML =
        "";

      before.forEach(
        (review) => {
          track.appendChild(
            createCard(
              review,
              true
            )
          );
        }
      );

      reviews.forEach(
        (review) => {
          track.appendChild(
            createCard(
              review
            )
          );
        }
      );

      after.forEach(
        (review) => {
          track.appendChild(
            createCard(
              review,
              true
            )
          );
        }
      );

      currentIndex =
        cloneCount +
        activeIndex;

      applyDimensions();

      requestAnimationFrame(
        () => {
          updatePosition(
            false
          );

          restartAutoplay();
        }
      );
    }

    /* ====================================================
       DOTS
       ==================================================== */

    function getVisibleDots(
      activeIndex
    ) {
      const maximumDots =
        7;

      if (
        reviews.length <=
        maximumDots
      ) {
        return reviews.map(
          (
            _,
            index
          ) =>
            index
        );
      }

      const start =
        Math.min(
          Math.max(
            activeIndex -
            3,
            0
          ),
          reviews.length -
          maximumDots
        );

      return Array.from(
        {
          length:
            maximumDots
        },
        (
          _,
          index
        ) =>
          start +
          index
      );
    }

    function renderDots() {
      const activeIndex =
        getActiveIndex();

      dots.innerHTML =
        "";

      dots.hidden =
        reviews.length <= 1;

      getVisibleDots(
        activeIndex
      ).forEach(
        (reviewIndex) => {
          const dot =
            document.createElement(
              "button"
            );

          dot.type =
            "button";

          dot.className =
            reviewIndex ===
            activeIndex
              ? "vry-dot is-active"
              : "vry-dot";

          dot.setAttribute(
            "aria-label",
            `${COPY.goTo} ${
              reviewIndex +
              1
            }`
          );

          dot.addEventListener(
            "click",
            () => {
              currentIndex =
                cloneCount +
                reviewIndex;

              updatePosition(
                true
              );

              restartAutoplay();
            }
          );

          dots.appendChild(
            dot
          );
        }
      );
    }

    /* ====================================================
       AUTOPLAY
       ==================================================== */

    function stopAutoplay() {
      if (
        autoplayTimer
      ) {
        window.clearTimeout(
          autoplayTimer
        );

        autoplayTimer =
          null;
      }
    }

    function canAutoplay() {
      if (
        !SETTINGS.autoplayEnabled ||
        reviews.length <= 1 ||
        prefersReducedMotion() ||
        !root.isConnected
      ) {
        return false;
      }

      if (
        SETTINGS.pauseAutoplayOnHover &&
        isHovering
      ) {
        return false;
      }

      if (
        SETTINGS.pauseAutoplayOnFocus &&
        hasFocusWithin
      ) {
        return false;
      }

      if (isTouching) {
        return false;
      }

      if (
        SETTINGS.pauseAutoplayWhenHidden &&
        document.hidden
      ) {
        return false;
      }

      return true;
    }

    function scheduleAutoplay() {
      stopAutoplay();

      if (
        !canAutoplay()
      ) {
        return;
      }

      autoplayTimer =
        window.setTimeout(
          () => {
            if (
              !canAutoplay()
            ) {
              return;
            }

            currentIndex +=
              1;

            updatePosition(
              true
            );

            scheduleAutoplay();
          },
          SETTINGS.autoplayDelay
        );
    }

    function restartAutoplay() {
      stopAutoplay();
      scheduleAutoplay();
    }

    /* ====================================================
       CONTROLS
       ==================================================== */

    function previous() {
      currentIndex -=
        1;

      updatePosition(
        true
      );

      restartAutoplay();
    }

    function next() {
      currentIndex +=
        1;

      updatePosition(
        true
      );

      restartAutoplay();
    }

    previousButton.addEventListener(
      "click",
      previous
    );

    nextButton.addEventListener(
      "click",
      next
    );

    viewport.addEventListener(
      "keydown",
      (event) => {
        if (
          event.key ===
          "ArrowLeft"
        ) {
          previous();
        }

        if (
          event.key ===
          "ArrowRight"
        ) {
          next();
        }
      }
    );

    /* ====================================================
       PAUSE EVENTS
       ==================================================== */

    stage.addEventListener(
      "mouseenter",
      () => {
        isHovering =
          true;

        stopAutoplay();
      }
    );

    stage.addEventListener(
      "mouseleave",
      () => {
        isHovering =
          false;

        restartAutoplay();
      }
    );

    root.addEventListener(
      "focusin",
      () => {
        hasFocusWithin =
          true;

        stopAutoplay();
      }
    );

    root.addEventListener(
      "focusout",
      () => {
        window.setTimeout(
          () => {
            hasFocusWithin =
              root.contains(
                document.activeElement
              );

            if (
              !hasFocusWithin
            ) {
              restartAutoplay();
            }
          },
          0
        );
      }
    );

    document.addEventListener(
      "visibilitychange",
      () => {
        if (
          document.hidden
        ) {
          stopAutoplay();
        } else {
          restartAutoplay();
        }
      }
    );

    /* ====================================================
       INFINITE LOOP
       ==================================================== */

    track.addEventListener(
      "transitionend",
      () => {
        if (
          currentIndex >=
          cloneCount +
          reviews.length
        ) {
          currentIndex -=
            reviews.length;

          updatePosition(
            false
          );

          return;
        }

        if (
          currentIndex <
          cloneCount
        ) {
          currentIndex +=
            reviews.length;

          updatePosition(
            false
          );
        }
      }
    );

    /* ====================================================
       TOUCH / SWIPE
       ==================================================== */

    viewport.addEventListener(
      "touchstart",
      (event) => {
        isTouching =
          true;

        stopAutoplay();

        touchStartX =
          event.touches[0]
            ?.clientX ??
          null;

        touchStartY =
          event.touches[0]
            ?.clientY ??
          null;
      },
      {
        passive: true
      }
    );

    viewport.addEventListener(
      "touchend",
      (event) => {
        if (
          touchStartX !==
            null &&
          touchStartY !==
            null
        ) {
          const endX =
            event
              .changedTouches[0]
              ?.clientX;

          const endY =
            event
              .changedTouches[0]
              ?.clientY;

          if (
            typeof endX ===
              "number" &&
            typeof endY ===
              "number"
          ) {
            const differenceX =
              endX -
              touchStartX;

            const differenceY =
              endY -
              touchStartY;

            if (
              Math.abs(
                differenceX
              ) > 40 &&
              Math.abs(
                differenceX
              ) >
              Math.abs(
                differenceY
              )
            ) {
              if (
                differenceX > 0
              ) {
                currentIndex -=
                  1;
              } else {
                currentIndex +=
                  1;
              }

              updatePosition(
                true
              );
            }
          }
        }

        touchStartX =
          null;

        touchStartY =
          null;

        isTouching =
          false;

        restartAutoplay();
      },
      {
        passive: true
      }
    );

    viewport.addEventListener(
      "touchcancel",
      () => {
        touchStartX =
          null;

        touchStartY =
          null;

        isTouching =
          false;

        restartAutoplay();
      },
      {
        passive: true
      }
    );

    /* ====================================================
       RESIZE
       ==================================================== */

    function handleResize() {
      const activeIndex =
        getActiveIndex();

      const newConfig =
        getConfig();

      const changed =
        !config ||
        newConfig.visibleCards !==
          config.visibleCards ||
        newConfig.gap !==
          config.gap ||
        newConfig.peek !==
          config.peek ||
        newConfig.minimumWidth !==
          config.minimumWidth;

      config =
        newConfig;

      if (changed) {
        buildCarousel(
          activeIndex
        );

        return;
      }

      applyDimensions();

      updatePosition(
        false
      );

      restartAutoplay();
    }

    if (
      "ResizeObserver" in
      window
    ) {
      const observer =
        new ResizeObserver(
          () => {
            window.clearTimeout(
              resizeTimer
            );

            resizeTimer =
              window.setTimeout(
                handleResize,
                100
              );
          }
        );

      observer.observe(
        viewport
      );
    } else {
      window.addEventListener(
        "resize",
        () => {
          window.clearTimeout(
            resizeTimer
          );

          resizeTimer =
            window.setTimeout(
              handleResize,
              100
            );
        }
      );
    }

    window.addEventListener(
      "pagehide",
      stopAutoplay,
      {
        once: true
      }
    );

    buildCarousel(0);
  }

  /* ======================================================
     INITIALISATION
     ====================================================== */

  function scanPage() {
    document
      .querySelectorAll(
        BLOCK_SELECTOR
      )
      .forEach(
        (block) => {
          updateHeader(
            block
          );

          enhanceBlock(
            block
          );
        }
      );
  }

  let scanScheduled =
    false;

  function scheduleScan() {
    if (
      scanScheduled
    ) {
      return;
    }

    scanScheduled =
      true;

    requestAnimationFrame(
      () => {
        scanScheduled =
          false;

        scanPage();
      }
    );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      scanPage,
      {
        once: true
      }
    );
  } else {
    scanPage();
  }

  new MutationObserver(
    scheduleScan
  ).observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  document.addEventListener(
    "shopify:section:load",
    scheduleScan
  );

  document.addEventListener(
    "shopify:block:select",
    scheduleScan
  );
})();